import _ from 'lodash';
import { planTypes, PBX_CATEGORYS } from '@/common/constants';
import { getCartInfo } from '@/common/service/default-mapper';
import { BASE_PLAN_SUB_TYPES } from '@/common/constants'

export default (raw) => {
  const path = `zoomone.zoom-one-edu-sch-cmp-plus`;
  const plans = _.get(raw, path, []);
  const ucPbxList = _.get(raw, 'pbxAudio.pbx.plans', []).filter((c) => c.sub_type === 'UC')

  return plans.reduce((acc, x) => {
    const plan = {
      type: planTypes.ZONE_EDU_PLUS,
      // sub_type: BASE_PLAN_SUB_TYPES.ZONE_EDU_PLUS,
      zoomMeetingCategory: BASE_PLAN_SUB_TYPES.ZONE_EDU_PLUS, // for audio pay as you go
      category: x.category_code,
      pbxCategory: ucPbxList.find((c) => c.region === x.region)?.category_code,
      plan_code: x.plan_code,
      plan_type: x.plan_type,
      amount: x.amount,
      region: x.region,
      billing_cycle: x.billing_cycle,
      parent_category: x.parent_category,
      cartInfo: getCartInfo(),
      supportCoupon: true,
      dependBasePlanTypeList: [],
      typeNameKey: 'billing.zone_edu_plus.title',
      planNameKey: 'billing.zone_edu_plus.title',
      parentPlanNameKey: 'Zoom One',
      isEdu: true, // for edu email validation
      defaultPbxBase: PBX_CATEGORYS.ZVP,
    };
    return [...acc, plan];
  }, []);
};
